import styled from "styled-components";
import { colors } from "../../consts";
import { Paragraph2, WrapperContainer } from "../../components";

export const ViewOnlyContainer = styled(WrapperContainer)`
  min-height: 48px;
  padding: 12px;

  border-radius: 8px;
  background: ${colors.ISABELLINE_DARKER};
`;

export const Placeholder = styled(Paragraph2)`
  color: ${colors.RAISIN_50};
`;
